import { ExtraType } from "../../extras/types";

/**
 * Category of an extra (proto enum `ExtraCategory`). The values are the codes received in issue
 * `params` and used as block keys, i.e. the proto value without the `EXTRA_CATEGORY_` prefix.
 */
export enum ExtraCategory {
  NONE = "NONE",
  VEHICLE = "VEHICLE",
  FACILITIES = "FACILITIES",
}

/** Extra types that can have a category: per unit & stay, per unit & night. */
export const SUPPORTED_EXTRA_TYPES: readonly ExtraType[] = Object.freeze([
  ExtraType.EXTRA_TYPE_UNIT,
  ExtraType.EXTRA_TYPE_UNIT_PER_DAY,
]);

const ASSIGNABLE_CATEGORIES: readonly ExtraCategory[] = Object.freeze([
  ExtraCategory.VEHICLE,
  ExtraCategory.FACILITIES,
]);

/** Rules of the closed category list. */
export class ExtraCategories {
  private constructor() {}

  /** Every value of the Category dropdown, *No category* first. */
  static all(): readonly ExtraCategory[] {
    return [ExtraCategory.NONE, ...ASSIGNABLE_CATEGORIES];
  }

  /** The categories that make an extra count against accommodation limits. */
  static assignable(): readonly ExtraCategory[] {
    return ASSIGNABLE_CATEGORIES;
  }

  static supportsExtraType(type: ExtraType | string | undefined): boolean {
    return SUPPORTED_EXTRA_TYPES.includes(type as ExtraType);
  }

  /** Parses a category code (e.g. an issue param); `undefined` when it is not a known code. */
  static parse(code: string | undefined): ExtraCategory | undefined {
    return Object.values(ExtraCategory).find(category => category === code);
  }

  static isAssignable(category: ExtraCategory): boolean {
    return ASSIGNABLE_CATEGORIES.includes(category);
  }
}
